import React, { useState, useEffect } from 'react';
import Select from "react-select";
import SelectSearch, { fuzzySearch } from "react-select-search";
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import TopFilter from '../components/TopFilter';
import DatePicker from 'react-date-picker';
import 'bootstrap/dist/js/bootstrap.min.js';

import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import PropTypes from 'prop-types';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import '../style/custom.css';
import configData from '../configData.json';
import AccServicesFreightBillAuditPayment from '../components/Settings/AccServicesFreightBillAuditPayment';
import AccServicesSupplyChain from '../components/Settings/AccServicesSupplyChain';
import AccAdditionalServicesUpsell from '../components/Settings/AccAdditionalServicesUpsell';
import AccBusinessPortionLostService from '../components/Settings/AccBusinessPortionLostService';
import AccBillableItems from '../components/Settings/AccBillableItems';
import AccContractAmendments from '../components/Settings/AccContractAmendments';
import AccBusinessReview from '../components/Settings/AccBusinessReview';
import AccServicesContractManagement from '../components/Settings/AccServicesContractManagement';
import SweetAlert from "react-bootstrap-sweetalert";
import { toLocalDate } from '../components/Utlities';
import { format } from 'date-fns';

export default function CustomerSettings() {

    const [detailData, setDetailData] = useState([]);
    const [contractManagementDetailData, setContractManagementDetailData] = useState([]);
    const [fbauditPaymentDetailData, setFbauditPaymentDetailData] = useState([]);
    const [supplyChainDetailData, setSupplyChainDetailData] = useState([]);
    const [upsellDetailData, setUpsellDetailData] = useState([]);
    const [businessLostDetailData, setBusiessLostDetailData] = useState([]);
    const [businessReviewDetailData, setBusinessReviewDetailData] = useState([]);
    const [contractAmendmentDetailData, setContractAmendmentDetailData] = useState([]);
    const [billableItemsDetailData, setBillableItemsDetailData] = useState([]);

    const [customerLoading, isCustomerLoading] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [selectedCust, setSelectedCust] = useState(0);
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [owners, setOwners] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [lastCloseDate, setLastCloseDate] = useState('');

    const [showAlert, setShowAlert] = useState(true);


    useEffect(() => {
        window.scrollTo(0, 0);
        LoadOwners();
    }, [])

    const updateFbAuditPaymentData = (updateFbAuditPaymentGridData) => {
        // debugger;
        setFbauditPaymentDetailData(updateFbAuditPaymentGridData);
        // console.log(fbauditPaymentDetailData);
    };

    const updateSupplyChainData = (updateSupplyChainGridData) => {
        setSupplyChainDetailData(updateSupplyChainGridData);
        // console.log(supplyChainDetailData);
    };

    const updateUpsellData = (updateUpsellGridData) => {
        // debugger;
        setUpsellDetailData(updateUpsellGridData);
        // console.log(upsellDetailData);
    };

    const updateBusinessLostData = (updateBusinessLostGridData) => {
        // debugger;
        setBusiessLostDetailData(updateBusinessLostGridData);
        // console.log(businessLostDetailData);
    };

    const updateBusinessReviewData = (updateBusinessLostGridData) => {
        // debugger;
        setBusinessReviewDetailData(updateBusinessLostGridData);
        // console.log(businessLostDetailData);
    };

    const updateContractManagementData = (updateContractManagementGridData) => {
        // debugger;
        setContractManagementDetailData(updateContractManagementGridData);
        // console.log(businessLostDetailData);
    };

    const updateContractAmendmentData = (updateContractAmendmentGridData) => {
        // debugger;
        setContractAmendmentDetailData(updateContractAmendmentGridData);
        // console.log(businessLostDetailData);
    };

    const updateBillableItemsData = (updateBillableItemsGridData) => {
        // debugger;
        setBillableItemsDetailData(updateBillableItemsGridData);
        // console.log(businessLostDetailData);
    };

    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;
        LoadCustomers(e);
        setSelectedCust(0);
        setLastCloseDate('');
    };

    const onCustomerSelect = (e) => {
        // debugger;
        var custkey = e;
        setLastCloseDate('');
        setSelectedCust(e);
        if (custkey > 0) {
            LoadDetailData(e);
            LoadLastCloseDate(e);
            // console.log(detailData);
        }
        document.querySelectorAll('.accordion .accordion-collapse').forEach(function (collapse) {
            collapse.classList.remove('collapsed');
            collapse.classList.add('show');
        });
    };


    const LoadOwners = async () => {
        // debugger;
        isOwnerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const own = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, own];
                })
                const defaultOwner = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomers(0);
    }

    const LoadCustomers = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isCustomerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCustomerLoading(false);
    }

    const LoadLastCloseDate = async (customerKey) => {
        setDetailData([]);
        const URL = `${configData.BASE_APP_URL}Customer/GetCustomerDetails/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                // Assuming the API response contains the lastCloseDate field
                if (resp.lastCloseDate === null || resp.lastCloseDate === "") {
                    // Set resp.lastCloseDate to blank
                    setLastCloseDate('');
                } else {
                    // Convert resp.lastCloseDate to the desired format
                    setLastCloseDate(format(toLocalDate(resp.lastCloseDate), "MM/dd/yyyy"));
                }
                // console.log(lastCloseDate);
            });
    }


    const LoadDetailData = async (customerKey) => {
        // setLoadingFunc(true);
        setDetailData([]);
        const URL = `${configData.BASE_APP_URL}CustomerSetup/GetCustomerSettings/${customerKey}/0`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                setDetailData(resp);
                // debugger;
                setFbauditPaymentDetailData(resp.filter(item => item.serviceType === "NV"));
                setSupplyChainDetailData(resp.filter(item => item.serviceType === "SC"));
                setUpsellDetailData(resp.filter(item => item.serviceType === "UP"));
                setBusiessLostDetailData(resp.filter(item => item.serviceType === "SL"));
                setBusinessReviewDetailData(resp.filter(item => item.serviceType === "BR"));
                // console.log(resp);
            })
    }


    const validateData = (combinedData) => {

        if (combinedData.length < 1) {
            return 'No data to save';
        }
        const isInvalid = (value) => {
            if (value === '' || value === 0 || value == null || value === undefined) {
                return true;
            }
            return false;
        };

        const isDirty = combinedData.some(item => item.dirtyFlag === 'I' || item.dirtyFlag === 'U');
        // if (isDirty) {

        debugger;
        if (combinedData.some(item => item.contractEffectiveDate === null && item.serviceType === 'CM')) {
            return 'Contract Effective Date must be entered';
        }
        if (combinedData.some(item => item.contractExpirationeDate === null && item.serviceType === 'CM')) {
            return 'Contract Expiration Date must be entered';
        }
        if (combinedData.some(item => (item.contractTerms === '' || item.contractTerms === null) && item.serviceType === 'CM')) {
            return 'Contract Terms must be entered';
        }
        if (combinedData.some(item =>
            (isInvalid(item.locationType) || isInvalid(item.locationTypeName)) && item.serviceType === 'CM')) {
            return 'Location Type must be entered';
        }
        if (combinedData.some(item =>
            (isInvalid(item.locationKey) || isInvalid(item.locationDesc)) && item.serviceType === 'CM')) {
            return 'Location Name must be entered';
        }
        if (combinedData.some(item => (item.renewalTerms === '' || item.renewalTerms === '0' || item.renewalTerms === null) && item.autoRenewal === 'Y' && item.serviceType === 'CM')) {
            return 'Terms of Renewal is required when Auto-Renewed is Yes’';
        }
        if (combinedData.some(item => item.notificationEmails === '' && item.serviceType === 'CM')) {
            return 'Notification Email must be entered';
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (combinedData.some(item => {
            if (item.notificationEmails !== '' && item.serviceType === 'CM') {
                const emails = item.notificationEmails.split(';').map(email => email.trim());
                return emails.some(email => !emailRegex.test(email));
            }
            return false;
        })) {
            return 'Notification Email must be in a valid format';
        }
        //#endregion

        //#region nVision Global Freight Bill Audit and Payment Validation
        if (combinedData.some(item => item.codeId === '' && item.serviceType === 'NV')) {
            return 'nVision Global Service is not selected';
        }
        if (combinedData.some(item => item.codeId !== '' && item.serviceDate === null && item.serviceType === 'NV')) {
            return 'Date of Service is required when a nVision Global Service is added’';
        }
        //#endregion

        //#region By nVision Supply Chain Services Validation
        if (combinedData.some(item => item.codeId === '' && item.serviceType === 'SC')) {
            return 'Supply Chain Service is not selected';
        }
        if (combinedData.some(item => item.codeId !== '' && item.serviceDate === null && item.serviceType === 'SC')) {
            return 'Date of Service is required when a Supply Chain Service is added’';
        }
        //#endregion

        //#region By Upsell Services Validation
        if (combinedData.some(item => item.codeId === '' && item.serviceType === 'UP')) {
            return 'Additional Service is not selected';
        }
        if (combinedData.some(item => item.codeId !== '' && item.serviceDate === null && item.serviceType === 'UP')) {
            return 'Date of Service is required when a Additional Service is added’';
        }
        //#endregion

        //#region By Business or Portion Lost Validation
        debugger;
        if (combinedData.some(item => item.codeType === '' && item.serviceType === 'SL')) {
            return 'Type Of Service is not selected';
        }
        if (combinedData.some(item => item.codeId === '' && item.serviceType === 'SL')) {
            return 'Business or Portion Lost Service Description is not selected';
        }
        if (combinedData.some(item => item.serviceDate === null && item.serviceType === 'SL')) {
            return 'Business or Portion Lost Date is required when Business or Portion Lost Service is added';
        }

        //#endregion

        //#region By Business Review Validation
        if (combinedData.some(item => item.leadBusinessReview === '' && item.serviceType === 'BR')) {
            return 'Lead Business Reviews is not selected';
        }
        //#endregion

        //#region By Contract Amendments Validation
        if (combinedData.some(item => item.amendmentDescription === '' && item.serviceType === 'CA')) {
            return 'Amendment Description cannot be blank';
        }
        if (combinedData.some(item => item.amendmentDescription !== '' && item.amendmentDate === null && item.serviceType === 'CA')) {
            return 'Amendment Date is required when an Amendment is added’’';
        }
        //#endregion

        //#region By Billable Items Validation
        if (combinedData.some(item => item.codeId === '' && item.serviceType === 'BI')) {
            return 'Item Description is not selected';
        }
        if (combinedData.some(item => item.firstPageRate === '' && item.serviceType === 'BI')) {
            return 'Rate Per Page is not entered';
        }
        if (combinedData.some(item => item.firstPageRange === '' && item.serviceType === 'BI')) {
            return 'First Page Range is not entered';
        }
        if (combinedData.some(item => item.nextPageRate === '' && item.serviceType === 'BI')) {
            return 'Next Page Rate is not entered';
        }
        if (combinedData.some(item => item.nextPageRange === '' && item.serviceType === 'BI')) {
            return 'Next Page Range is not entered';
        }

        //#endregion
        return null; // Indicates that data is valid and can be saved
        // } else {
        //     setShowAlert(true);
        //     return 'No changes have been made.';
        // }
    };

    const saveCombinedDataToFile = (combinedData) => {
        const combinedDataString = JSON.stringify(combinedData);
        const blob = new Blob([combinedDataString], { type: 'text/plain' });

        const downloadLink = document.createElement('a');
        downloadLink.download = 'combinedData.txt';
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.click();
    };

    const handleSave = () => {
        // Open Sweet Alert confirmation
        const combinedData = [
            ...contractManagementDetailData,
            ...fbauditPaymentDetailData,
            ...supplyChainDetailData,
            ...upsellDetailData,
            ...businessLostDetailData,
            ...businessReviewDetailData,
            ...contractAmendmentDetailData,
            ...billableItemsDetailData
        ];

        const validationMessage = validateData(combinedData);

        if (validationMessage === null) {
            setShowAlert(false);
        } else {
            // Handle validation error
            window.confirm(validationMessage);
        }

    };

    const onConfirmFunc = async () => {
        setShowAlert(true);

        const combinedData = [
            ...contractManagementDetailData,
            ...fbauditPaymentDetailData,
            ...supplyChainDetailData,
            ...upsellDetailData,
            ...businessLostDetailData,
            ...businessReviewDetailData,
            ...contractAmendmentDetailData,
            ...billableItemsDetailData
        ];

        try {
            const saveUrl = `${configData.BASE_APP_URL}CustomerSetup/SaveCustomerSettings`;

            const response = await fetch(saveUrl, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                },
                body: JSON.stringify(combinedData)
            });
            debugger;
            console.log(JSON.stringify(combinedData));
            if (response.ok) {
                // Data saved successfully
                LoadDetailData(selectedCust); // Reload data if needed
                window.alert('Data Saved Successfully');
            } else {
                // Handle server error or failed save
                const errorData = await response.text();
                window.alert(errorData);
            }
        } catch (error) {
            // Handle fetch or other errors
            console.error('Error:', error);
        }

    };

    const onCancelFunc = () => {
        setShowAlert(true);
        // Handle cancellation if needed
    };

    const handleDeleteRows = (deletedRowCount) => {
        // debugger;
        // Perform any actions needed for deleting multiple rows
        // console.log(`${deletedRowCount} rows deleted.`);
        // window.confirm(`${deletedRowCount} rows deleted.`)
        // if (window.confirm(confirmationMessage)) {
        //     LoadDetailData(selectedCust);
        // }
    };


    return (
        <>
            <div hidden={showAlert}>
                <SweetAlert
                    customButtons={
                        <React.Fragment>
                            <button className='btn btn-clear' onClick={onCancelFunc}>Cancel</button>
                            <button className='btn btn-filter ms-2' onClick={onConfirmFunc}>Confrm</button>
                        </React.Fragment>
                    }
                    showCancel
                    confirmBtnText="Save"
                    confirmBtnBsStyle="success"
                    cancelBtnText="Cancel"
                    title="Do you want to save the changes?"
                    onConfirm={onConfirmFunc}
                    onCancel={onCancelFunc}
                    focusConfirmBtn
                >
                </SweetAlert>
            </div>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />

                    <div className='pt-1 px-3 pb-3 py-3'>

                        <Breadcrumbs title="Settings" />
                        {/* {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
            */}
                        <div className='sticky-top-content'>
                            <div className='top-filter-container mb-1 py-2 px-2 border rounded-1'>

                                <div className='row'>

                                    <div className='col-3 top-info'>

                                        <div className="mb-2 form-field">

                                            <label>Owner</label>
                                            <div>
                                                <SelectSearch
                                                    id="ddnOwn"
                                                    name="ddnOwn"
                                                    value={selectedOwner}
                                                    options={owners}
                                                    onChange={onOwnerSelect}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-3 top-info'>

                                        <div className="mb-2 form-field">

                                            <label>Customer</label>
                                            <div>
                                                <SelectSearch
                                                    id="ddnCustomer"
                                                    name="ddnCustomer"
                                                    // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                                                    value={selectedCust}
                                                    options={customers}
                                                    onChange={onCustomerSelect}
                                                    search
                                                    filterOptions={fuzzySearch}
                                                >
                                                </SelectSearch>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-2 top-info'>
                                        <div className="mb-2 form-field">

                                            <label>Last Close Date</label>

                                            <div className="mt-2">
                                                <span>{lastCloseDate}</span>
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                        {selectedCust > 0 && (
                            <div className="accordion" id="accordionSettings">
                                {/* <ServicesContractManagement detailData={detailData} /> */}
                                <AccServicesContractManagement sccData={detailData}
                                    onUpdateGridData={updateContractManagementData}
                                    selectedCust={selectedCust}
                                />

                                {/* <ServicesFreightBillAuditPayment sccData={detailData}  /> */}
                                {/* <AccGridComponent /> */}

                                <AccServicesFreightBillAuditPayment
                                    sccData={detailData}
                                    onUpdateGridData={updateFbAuditPaymentData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />

                                {/* <ServicesSupplyChain sccData={detailData} /> */}

                                <AccServicesSupplyChain sccData={detailData}
                                    onUpdateGridData={updateSupplyChainData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />

                                {/* <AdditionalServicesUpsell sccData={detailData} /> */}

                                <AccAdditionalServicesUpsell sccData={detailData}
                                    onUpdateGridData={updateUpsellData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />

                                {/* <BusinessPortionLostService sccData={detailData}  /> */}

                                <AccBusinessPortionLostService sccData={detailData}
                                    onUpdateGridData={updateBusinessLostData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />

                                {/* <BusinessReview /> */}

                                <AccBusinessReview sccData={detailData}
                                    onUpdateGridData={updateBusinessReviewData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />

                                {/* <ContractAmendments /> */}
                                <AccContractAmendments sccData={detailData}
                                    onUpdateGridData={updateContractAmendmentData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />


                                {/* <BillableItems /> */}
                                <AccBillableItems sccData={detailData}
                                    onUpdateGridData={updateBillableItemsData}
                                    onDeleteRows={handleDeleteRows}
                                    selectedCust={selectedCust}
                                />


                            </div>
                        )}

                        {selectedCust > 0 && (
                            <div className='row'>

                                <div className='col-12 mt-2'>
                                    <div className="form-field mx-auto" style={{ width: "180px" }}>
                                        {/* <button type="button" onClick={{}} className='btn btn-clear'>Cancel</button> */}
                                        <button type="button" onClick={handleSave} className='btn btn-filter ms-2'>Save</button>
                                    </div>

                                </div>

                            </div>
                        )}

                    </div>
                </div>
            </div>

        </>
    )
}
